import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import DateRangePicker from '../../Pages/Dashboard/DateRangePicker';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

const DateRangeField = function DateRangeField({
  id,
  value = [null, null],
  onChange = () => {},
  label,
  disableMinDate = false,
}) {
  const intl = useIntl();

  const [rangeValue, setRangeValue] = useState(value);
  const [rangeDialog, setRangeDialog] = useState(false);

  const handleCloseRangeDialog = () => {
    setRangeDialog(false);
  };

  const handleChangeRange = (newRange) => {
    setRangeValue(newRange);
    onChange(newRange);
  };

  return (
    <>
      <TextField
        id={id}
        label={intl.messages[label] || label}
        onClick={() => setRangeDialog(true)}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  disabled={!rangeValue[0] && !rangeValue[1]}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleChangeRange([null, null]);
                  }}
                >
                  <CloseRoundedIcon />
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
        value={
          rangeValue[0] && rangeValue[1]
            ? `${new Date(rangeValue[0]).toLocaleDateString()} - ${new Date(
                rangeValue[1]
              ).toLocaleDateString()}`
            : ''
        }
      />
      <DateRangePicker
        open={rangeDialog}
        close={handleCloseRangeDialog}
        periodRange={rangeValue}
        setPeriodRange={handleChangeRange}
        disableMaxDate
        disableMinDate={disableMinDate}
        title={label}
      />
    </>
  );
};

export default DateRangeField;
